import React from 'react';
import { InfoInCircle } from '@td-client-frontend/icons';
import { LabelWithIconTooltip } from '@td-client-frontend/common';

export const Tooltip = ({ text, type }: { text: string; type: string }) => (
  <LabelWithIconTooltip
    dataFor={`tooltip-for-${type}`}
    tooltipBody={text}
    tooltipIcon={<InfoInCircle />}
    tooltipSetting={{
      className: 'w-96 !opacity-100',
      border: false
    }}
    wrapperClasses="flex items-center mb-2"
    labelClasses="font-effra text-gray-60 text-lg"
  />
);
